module.exports = __webpack_public_path__ + "front/img/6.96d2c3e7.png";